const config = {
  tokenName: 'applyToken',
  baseUrl: './',
  // baseUrl: 'http://apply.hzxunwen.com/',
  // 手机号正则
  PhoneNumReg: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
  // 邮箱正则
  EmailReg: /^([a-zA-Z0-9]+[_|_|\-|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/,
  // 数字正则
  NumberReg: /^[0-9]*$/,
  // 非负浮点数正则
  FloatReg: /^[1-9]\d*\.\d*|0\.\d*[1-9]\d*|0?\.0+|0$/,
  // 中文正则
  ChineseReg: /[\u4e00-\u9fa5]/,
  // 身份证正则
  IDCard18: /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/
};

export default config;



// WEBPACK FOOTER //
// ./src/config/index.js